export default __webpack_public_path__ + "6159548d281704894cb45e250aa802f6.png";